<template>
  <div>
    <div :id="currentComponentId" />
  </div>
</template>

<script>
import { createId } from '@/utils/index.js'

export default {
  name: 'VerifyTac',
  data () {
    let tacPromiseResolve = null
    let tacPromiseReject = null
    const tacLoadPromise = new Promise((resolve, reject) => {
        tacPromiseResolve = resolve
        tacPromiseReject = reject
    })
    return {
      currentComponentId: 'captcha-box-' + createId(),
      tac:null,
      tacLoadPromise,
      tacPromiseResolve,
      tacPromiseReject
    }
  },
  mounted () {
    this.initLoad()
  },
  methods: {
    initLoad () {
        const vm = this
      // config 对象为TAC验证码的一些配置和验证的回调
      const config = {
        // 生成接口 (必选项,必须配置, 要符合tianai-captcha默认验证码生成接口规范)
        requestCaptchaDataUrl: process.env.VERIFY_BASE_URL+'/v1/captcha/get',
        // 验证接口 (必选项,必须配置, 要符合tianai-captcha默认验证码校验接口规范)
        validCaptchaUrl: process.env.VERIFY_BASE_URL+'/v1/captcha/check',
        // 验证码绑定的div块 (必选项,必须配置)
        bindEl: `#${this.currentComponentId}`,
        // 校验成功时的提示信息
        // validSuccessTipMsg(res,useTimes){
        //     // res: 服务端返回的验证码校验结果
        //     // useTimes: 验证码校验成功后滑动的时间（秒）
        // },
        // 校验失败时的提示信息
        validFailTipMsg(res){
            // res: 服务端返回的验证码校验结果
            return '验证失败，请重新尝试!'
        },
        // 校验请求发送参数序列化方法
        validCaptchaSendParamSerializer (param) {
          return {
            id: param.id,
            track: param.data
          }
        },
        // 校验请求url序列化方法
        // validCaptchaUrlSerializer(url, id, data) {
        //   return url + '?id=' + id
        // },
        responseInterceptor (res) {
          return res.data
        },
        // 验证成功回调函数(必选项,必须配置)
        validSuccess: (res, c, tac) => {
          // 销毁验证码服务
          vm.$emit("valid-success",res,tac, c)
        },
        // 验证失败的回调函数(可忽略，如果不自定义 validFail 方法时，会使用默认的)
        validFail: (res, c, tac) => {
          // 验证失败后重新拉取验证码
          tac.reloadCaptcha()
          vm.$emit("valid-fail",res,tac, c)
        },
        // 刷新按钮回调事件
        btnRefreshFun: (el, tac) => {
          tac.reloadCaptcha()
          vm.$emit("btn-on-refresh",tac, el)
        },
        // 关闭按钮回调事件
        btnCloseFun: (el, tac) => {
          tac.destroyWindow()
          vm.$emit("btn-on-close",tac, el)
        }
      }
      // 一些样式配置， 可不传
      const style = {
        logoUrl: null// 去除logo
        // logoUrl: "/xx/xx/xxx.png" // 替换成自定义的logo
      }
      // 参数1 为 tac文件是目录地址， 目录里包含 tac的js和css等文件
      // 参数2 为 tac验证码相关配置
      // 参数3 为 tac窗口一些样式配置
      window.initTAC('./static/tac', config, style).then(tac => {
        this.tac = tac
        this.tacPromiseResolve()
      }).catch(e => {
        console.log('初始化tac失败', e)
      })
    },
    async init(){
        await this.tacLoadPromise
        if(!this.tac || !this.tacLoadPromise){
            return
        }
        this.tac.init()
    }
  }
}

</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Verify/VerifyTac.vue